import { useQuery } from 'react-query';
import { fetchTeamChangeLog } from 'react-scale/components/ExpertManagement/ExpertManagementPage/api';

const useFetchTeamChangeLog = (managerId: string) => {
  const { data, isLoading: loading } = useQuery(
    [fetchTeamChangeLog, managerId],
    () => fetchTeamChangeLog(managerId),
    {},
  );
  return { events: data?.events ?? [], loading, managerId };
};

export default useFetchTeamChangeLog;
